import { render } from "./Category.vue?vue&type=template&id=4c0bf478&scoped=true"
import script from "./Category.js?vue&type=script&lang=js&external"
export * from "./Category.js?vue&type=script&lang=js&external"

import "./Category.vue?vue&type=style&index=0&id=4c0bf478&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0bf478"]])

export default __exports__